import React from "react";
import { Lock } from "lucide-react";

/**
 * Permission-denied state. Truthful message; never fake a screen for a role
 * that lacks permission.
 * @param {Object} props
 * @param {string} [props.requiredPermission]
 */
export function PermissionDenied({ requiredPermission, contact = "your Administrator" }) {
  return (
    <div className="ds-state">
      <div className="ds-state-icon"><Lock size={28} /></div>
      <div className="ds-state-title">You don't have permission</div>
      <div className="ds-state-hint">
        {requiredPermission
          ? <>This action requires <code>{requiredPermission}</code>. Ask {contact}.</>
          : <>Ask {contact} for access.</>}
      </div>
    </div>
  );
}
